var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.011 130.277C141.086 147.916 121.684 159.058 100.291 159.058C78.8986 159.058 59.516 147.916 48.571 130.277H22.9199C35.835 161.45 66.2223 182 100.291 182C134.38 182 164.767 161.43 177.662 130.277H152.011Z",
    fill: "url(#paint0_linear_3163_8592)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3127 110.345C19.5967 110.345 7 102.571 7 89.1171H27.5965C27.5965 93.841 31.1188 96.1531 35.8351 96.1531C39.9544 96.1531 42.3822 94.698 42.3822 91.788C42.3822 81.9615 8.0945 92.1467 8.0945 66.6737C8.0945 54.296 19.4773 47.26 34.5018 47.26C50.6208 47.26 62.7399 56.2493 62.7399 67.8896H42.1434C42.1434 64.242 39.1186 61.4516 34.9993 61.4516C31.477 61.4516 29.0691 62.9066 29.0691 65.4579C29.0691 74.3276 63.8344 64.9795 63.8344 90.3329C63.8344 103.169 52.0735 110.345 36.3127 110.345Z",
    fill: "#003A86"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.956 100.518C167.553 106.837 161.145 110.345 153.265 110.345C141.265 110.345 132.43 103.07 132.43 88.3797V48.4561H156.051V82.3204C156.051 88.9976 158.479 92.1469 162.956 92.1469C167.673 92.1469 169.981 88.9976 169.981 82.3204V48.4561H193.602V109.129H170.956V100.518Z",
    fill: "#003A86"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.425 75.7428L130.261 48.456H104.211L91.3759 73.4507V18L67.7546 29.9592V109.129H91.3759V78.0549L105.306 109.129H131.116L113.425 75.7428Z",
    fill: "#003A86"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3163_8592",
    x1: 22.9265,
    y1: 156.138,
    x2: 177.685,
    y2: 156.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5139,
    stopColor: "#FF0200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A12CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallIcon);
export default __webpack_public_path__ + "static/media/small-icon.387292657fe1ea0ada4f774ed63addc5.svg";
export { ForwardRef as ReactComponent };